'use client';

import { useEffect } from 'react';
import { CONSENT_CHANGE_EVENT, readConsentSnapshot } from '@/lib/consent';

const TWITTER_PIXEL_ID = 'qgi6h';

function loadTwitterPixel() {
    if (window.twq) return;

    const twq = function (...args) {
        if (twq.exe) twq.exe(...args);
        else twq.queue.push(args);
    };

    twq.version = '1.1';
    twq.queue = [];
    window.twq = twq;

    const script = document.createElement('script');
    script.id = 'twitter-pixel-script';
    script.async = true;
    script.src = 'https://static.ads-twitter.com/uwt.js';
    document.head.appendChild(script);

    twq('config', TWITTER_PIXEL_ID);
}

export function TwitterPixel() {
    useEffect(() => {
        function handleConsentChange(event) {
            if (event.detail.advertising) loadTwitterPixel();
        }

        if (readConsentSnapshot().advertising) loadTwitterPixel();
        window.addEventListener(CONSENT_CHANGE_EVENT, handleConsentChange);
        return () => window.removeEventListener(CONSENT_CHANGE_EVENT, handleConsentChange);
    }, []);

    return null;
}
